import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { LuSelectOptions, LuSelectUrlOptions } from 'lu-select';

@Component({
	templateUrl: './lu-select-formly.component.html'
})
export class LuSelectFormlyComponent extends FieldType implements OnInit {
	selectOptions: LuSelectOptions;
	urlOptions: LuSelectUrlOptions;
	items = [];

	ngOnInit(): void {
		if (!!this.to.luSelectOptions) {
			this.to.luSelectOptions.id = this.field.id;
			this.selectOptions = this.to.luSelectOptions;

			if (!!this.to.readonly) {
				this.selectOptions.readonly = this.to.readonly;
			}

			if (!!this.to.disabled) {
				this.selectOptions.disabled = this.to.disabled;
			}
		}

		if (!!this.to.luSelectUrlOptions) {
			this.urlOptions = this.to.luSelectUrlOptions;
		}

		if (!!this.to.luSelectItems) {
			this.items = this.to.luSelectItems;
		}
	}

	change($event): void {
		if (!!this.to && !!this.to.change) {
			this.to.change($event, this.field);
		}
	}

	selectReady($event): void {
		if (!!this.to && !!this.to.selectReady) {
			this.to.selectReady($event);
		}
	}

	loadedData($event): void {
		if (!!this.to && !!this.to.loadedData) {
			this.to.loadedData($event);
		}
	}
}
